<template>
  <div class="setting-main-container" v-if="getBusinessPermission || userType=='super_admin'">
      <div class="card setting-card">
        <div class="page-header">
          <h3 class="page-title">{{ $t('profile.financial_institutions.financial_institutions') }}</h3>
        </div>
        <div class="row">
            <div class="col-md-6 mb-4">
                <label class="input-label">{{ $tc('profile.financial_institutions.imports') }}</label>
                <p v-if="business && business.imports !=null ">{{ business.imports }}</p>
            </div>
            <div class="col-md-6 mb-4">
                <label class="input-label">{{ $tc('profile.financial_institutions.exports') }}</label>
                <p v-if="business && business.exports !=null ">{{ business.exports }}</p>
            </div>
            <div class="col-md-12 mb-4">
                <label class="input-label">{{ $tc('profile.financial_institutions.remittances_effect') }}</label>
                <p v-if="business && business.remittances_effected !=null ">{{ business.remittances_effected }}</p>
            </div>
        </div>
      </div>
  </div>
</template>
<script>

import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'
const { required, email, maxLength } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
      isLoading: false,
      userType:null,
    }
  },
  watch: {},
  validations: {},
  computed: {
    ...mapGetters('business', [
      'business',
      'getBusinessPermission'
    ]),

  },
  created() {
      if(localStorage.getItem('role')=='super_admin'){
       this.userType='super_admin';
      }
      if(localStorage.getItem('role')=='super_admin' && this.business==null){
        this.getBusinessData();
      }
      this.checkBusinessPermission();
  },
  mounted () {},
  methods: {
    ...mapActions('business', [
        'BusinessPermission',
        'falseBusinessPermission',
        'fetchBusinessByUser'
    ]),
    checkBusinessPermission(){
        this.BusinessPermission(this.$route.params.id)
    },
    async getBusinessData(){
      let formData = {
          user_id : this.$route.params.id,
      }
      let  response = await this.fetchBusinessByUser(formData)
    }
  }
}
</script>
